"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.string.link.js");
var _react = _interopRequireWildcard(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TooltipHeader = /*#__PURE__*/function (_Component) {
  _inherits(TooltipHeader, _Component);
  var _super = _createSuper(TooltipHeader);
  function TooltipHeader() {
    _classCallCheck(this, TooltipHeader);
    return _super.apply(this, arguments);
  }
  _createClass(TooltipHeader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message.Header, null, _lodash.default.upperFirst(this.props.children));
    }
  }]);
  return TooltipHeader;
}(_react.Component);
var Tooltip = /*#__PURE__*/function (_Component2) {
  _inherits(Tooltip, _Component2);
  var _super2 = _createSuper(Tooltip);
  function Tooltip(props) {
    var _this;
    _classCallCheck(this, Tooltip);
    _this = _super2.call(this, props);
    _this.handleDismiss = function () {
      _this.setState({
        visible: false
      });
    };
    _this.createLink = function (link, linkText) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: link
      }, " ", linkText);
    };
    _this.state = {
      dismissable: false,
      visible: true
    };
    return _this;
  }
  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        header = _this$props.header,
        content = _this$props.content,
        link = _this$props.link,
        linkText = _this$props.linkText,
        htmlContent = _this$props.htmlContent,
        popup = _this$props.popup,
        label = _this$props.label,
        input = _this$props.input;
      var popupCode;

      // Handle for popups used for tooltips
      if (popup != undefined) {
        var contentParts = htmlContent.split("<a>".concat(popup.link, "</a>"));
        popupCode = /*#__PURE__*/_react.default.createElement("div", null, contentParts[0], /*#__PURE__*/_react.default.createElement(_semanticUiReact.Popup, {
          trigger: !label ? /*#__PURE__*/_react.default.createElement("a", {
            href: "#",
            title: "info"
          }, popup.link, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
            name: "info circle",
            size: "small",
            color: "blue"
          })) : /*#__PURE__*/_react.default.createElement("label", {
            for: input
          }, /*#__PURE__*/_react.default.createElement("strong", null, popup.link), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
            name: "info circle",
            size: "small",
            color: "blue"
          })),
          position: popup.position ? popup.position : 'top center',
          style: popup.style,
          flowing: true,
          hoverable: true
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
          right: true,
          divided: true,
          columns: 1
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
          textAlign: "left"
        }, (0, _reactHtmlParser.default)(popup.text)))), contentParts[1]);
      }
      return this.state.visible ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message.Content, null, header && /*#__PURE__*/_react.default.createElement(TooltipHeader, null, _lodash.default.upperFirst(header)), popup ? popupCode : htmlContent && (0, _reactHtmlParser.default)(htmlContent), content && _lodash.default.upperFirst(content), this.props.children, /*#__PURE__*/_react.default.createElement("p", null, link && this.createLink(link, linkText)))) : null;
    }
  }]);
  return Tooltip;
}(_react.Component);
Tooltip.propTypes = {
  header: _propTypes.default.string.isRequired,
  content: _propTypes.default.string,
  link: _propTypes.default.string,
  linkText: _propTypes.default.string
};
Tooltip.defaultProps = {
  linkText: 'View submitted requests'
};
Tooltip.Header = TooltipHeader;
var _default = Tooltip;
exports.default = _default;